import { api } from './client';
import type { Mailbox } from '@/types';

export interface AddMailboxInput {
  email: string;
  password: string;
  category: 'personal' | 'business';
  businessId?: string | null;
  displayName?: string;
}

export interface MailboxResponse {
  mailbox: Mailbox;
}

export interface MailboxesResponse {
  mailboxes: Mailbox[];
}

export async function listMailboxes(): Promise<MailboxesResponse> {
  return api.get<MailboxesResponse>('/mailboxes');
}

export async function addMailbox(input: AddMailboxInput): Promise<MailboxResponse> {
  return api.post<MailboxResponse>('/mailboxes', input);
}

export interface VerifyResult {
  ok: boolean;
  failedStep?: 'discover' | 'connect' | 'auth';
  error?: string;
}

export async function verifyMailbox(email: string, password: string): Promise<VerifyResult> {
  return api.post<VerifyResult>('/mailboxes/verify', { email, password });
}

export async function updateMailbox(id: string, updates: Partial<Mailbox>): Promise<MailboxResponse> {
  return api.patch<MailboxResponse>(`/mailboxes/${id}`, updates);
}

export async function deleteMailbox(id: string): Promise<{ ok: boolean }> {
  return api.delete<{ ok: boolean }>(`/mailboxes/${id}`);
}

export async function changeMailboxPassword(id: string, newPassword: string): Promise<{ ok: boolean; verified: boolean }> {
  return api.post<{ ok: boolean; verified: boolean }>(`/mailboxes/${id}/change-password`, { newPassword });
}

export async function testMailbox(id: string): Promise<{ ok: boolean; folders?: { path: string; specialUse: string | null }[]; error?: string }> {
  return api.post<{ ok: boolean; folders?: { path: string; specialUse: string | null }[]; error?: string }>(`/mailboxes/${id}/test`);
}

export async function discoverMailbox(id: string): Promise<MailboxResponse> {
  return api.post<MailboxResponse>(`/mailboxes/${id}/discover`);
}
